export const API_URL =
  process.env.USE_LOAD_BALANCER_API === 'true'
    ? `${window.location.origin}/api`
    : process.env.API_SERVICE_URL;

console.log('USE_LOAD_BALANCER_API', process.env.USE_LOAD_BALANCER_API, 'API_URL', API_URL);
